import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OauthTokenDataObject } from '../../../models/service/login';

type LoginWithPasswordRequest = {
  grant_type: 'password';
  join_community_id?: string;
  password: string;
  provider: 'local';
  username: string;
};

export const loginWithPassword = async (data: LoginWithPasswordRequest) =>
  apiClient.post<OauthTokenDataObject, ApiClientResponse<OauthTokenDataObject>>(routes.oauth.token, data, {
    skipAuth: true,
  });
